export const neutral = {
    90: "#151F28",
    80: "#223240",
    70: "#2A3E50",
    60: "#566473",
    50: "#7F8B95",
    40: "#AAB2B9",
    30: "#E0E2E5",
    20: "#EAECEF",
    10: "#F0F5FA",
    "10A": "rgba(12, 22, 54, 0.03)",
    "20A": "rgba(1, 27, 51, 0.06)",
    "30A": "rgba(20, 42, 61, 0.14)",
    "40A": "rgba(0, 24, 46, 0.36)",
    "50A": "rgba(0, 24, 46, 0.5)",
};
